import React, { Fragment } from 'react';
import enhance from './Deals.enhancer';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import { dealStatuses } from '../../constants';
import LinkText from '../shared/components/LinkText';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Dialog from '@material-ui/core/Dialog';
import StarRatings from 'react-star-ratings';
import CircularProgress from '@material-ui/core/CircularProgress';
import HpDialog from '../shared/components/hpDialog';

class DealTable extends React.Component {
  constructor() {
    super();

    this.initialState = {
      showRatingsDialog: false,
      showUnmatchDialog: false,
      dealToUnmatch: {},
      dealToRate: {}
    };

    this.state = {
      ...this.initialState
    };
  }

  getStatusTextClass(status) {
    switch (status) {
      case dealStatuses.MATCHED:
        return this.props.classes.matchedStatus;
    }
  }

  handleChangeIndex = index => {
    this.setState({
      index
    });
  };

  navigateToCreateCampaign() {
    this.props.history.push(`/campaign/new`);
  }

  navigateToDiscoverCampaigns() {
    this.props.history.push(`/discover`);
  }

  navigateToProfile(userId) {
    this.props.history.push(`/user/${userId}/profile`);
  }

  navigateToCampaign(campaignId) {
    this.props.history.push(`/campaigns/${campaignId}`);
  }

  archiveDealClick(deal, dealRecipient, rateDeal) {
    // check if the other user has a rating associated with this deal
    if (rateDeal) {
      this.props.firestore
        .collection('ratings')
        .where('dealId', '==', deal.id)
        .where('ratedUser', '==', dealRecipient.uid)
        .get()
        .then(ratingDoc => {
          if (ratingDoc.empty) {
            //popup the rating dialog
            this.setState({
              showRatingsDialog: true,
              dealToRate: deal
            });
          } else {
            this.props.archiveDealHandler(deal.id, !dealRecipient.isCompany);
          }
        });
    } else {
      this.props.archiveDealHandler(deal.id, !dealRecipient.isCompany);
      this.setState({
        showRatingsDialog: false,
        dealToRate: deal
      });
    }
  }

  handleCloseRatingDialog() {
    this.setState({
      showRatingsDialog: false
    });
  }

  changeRating(newRating) {
    this.props.addRatingHandler(
      this.state.dealToRate.id,
      this.state.dealToRate.user.isCompany
        ? this.state.dealToRate.influencerId
        : this.state.dealToRate.companyId,
      this.state.dealToRate.user.uid,
      newRating
    );
    this.props.archiveDealHandler(
      this.state.dealToRate.id,
      !this.state.dealToRate.user.isCompany
    );
    this.setState({
      dealToRate: {},
      showRatingsDialog: false
    });
  }

  navigateToDiscoverInfluencers() {
    this.props.history.push(`discover-influencers`);
  }

  navigateToMatchFeed() {
    this.props.history.push(`matchFeed`);
  }

  closeUnmatchDialog = () => {
    this.setState({
      showUnmatchDialog: false
    });
  };

  openUnmatchDialog = row => {
    this.setState({
      dealToUnmatch: row,
      showUnmatchDialog: true
    });
  };

  confirmUmatch = () => {
    this.closeUnmatchDialog();
    this.props.handleUnmatchDealClick(this.state.dealToUnmatch);
  };

  render() {
    const {
      classes,
      tableRows,
      rowsLoaded,
      viewSelectChangeHandler,
      tableView,
      handleProposeDealClick,
      handleUnmatchDealClick,
      handleViewProposalClick,
      handleEscrowFundsClick,
      handleSubmitContentClick,
      handleOpenCompleteModal,
      handleReviewContentClick,
      handleViewDealClick,
      isCompany,
      viewStates,
      hasCampaign,
      campaignsLoaded,
      escrowReleaseIsProcessing,
      acceptDealInProgress,
      campaignId,
      auth
    } = this.props;

    return (
      <React.Fragment>
        {(escrowReleaseIsProcessing || acceptDealInProgress) && (
          <div className={classes.spinnerContainer}>
            <CircularProgress className={classes.downArrow} />
          </div>
        )}
        <main className={classes.layout}>
          {!campaignId && (
            <Typography variant="h3" id="tableTitle" className={classes.title}>
              Deals
            </Typography>
          )}
          <div>
            <TextField
              id="viewSelect"
              name="viewSelect"
              select
              className={classes.select}
              SelectProps={{
                MenuProps: {
                  className: classes.selectMenu
                }
              }}
              margin="normal"
              variant="outlined"
              onChange={viewSelectChangeHandler}
              value={tableView}
            >
              {viewStates.map((item, i) => (
                <MenuItem key={i} value={item.key}>
                  {item.value}
                </MenuItem>
              ))}
            </TextField>
          </div>
          {tableRows &&
            rowsLoaded &&
            tableRows.map(row => (
              <Paper className={classes.root}>
                <div className={classes.dealContainer}>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid
                      container
                      item
                      lg={4}
                      md={4}
                      sm={6}
                      xs={12}
                      alignItems="center"
                      spacing={2}
                    >
                      <Grid item>
                        <img
                          src={row.user.profilePictureUrl}
                          className={classes.circleImage}
                        />
                      </Grid>
                      <Grid item>
                        <LinkText
                          variant="h6"
                          onClick={() => this.navigateToProfile(row.user.uid)}
                        >
                          {row.user.displayName}
                        </LinkText>
                      </Grid>
                    </Grid>
                    <Grid item lg={5} md={5} sm={6} xs={12}>
                      <LinkText
                        variant="h6"
                        className={classes.linkStyle}
                        onClick={() => this.navigateToCampaign(row.campaignId)}
                      >
                        {row.campaign ? row.campaign.name : ''}
                      </LinkText>
                    </Grid>
                    <Grid
                      item
                      container
                      lg={3}
                      md={3}
                      xs={12}
                      alignItems="center"
                      spacing={2}
                    >
                      {/* MATCHED STATE BUTTONS */}
                      {isCompany && row.status === dealStatuses.MATCHED && (
                        <Fragment>
                          <Grid item>
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.acceptButton}
                              onClick={() => handleProposeDealClick(row)}
                            >
                              Propose Deal
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              color="secondary"
                              className={classes.unmatchButton}
                              variant="outlined"
                              onClick={() => this.openUnmatchDialog(row)}
                            >
                              Unmatch
                            </Button>
                          </Grid>
                        </Fragment>
                      )}
                      {!isCompany && row.status === dealStatuses.MATCHED && (
                        <Fragment>
                          <Grid item>
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.acceptButton}
                              onClick={() => handleProposeDealClick(row)}
                            >
                              Propose Deal
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              color="secondary"
                              className={classes.unmatchButton}
                              variant="outlined"
                              onClick={() => this.openUnmatchDialog(row)}
                            >
                              Unmatch
                            </Button>
                          </Grid>
                        </Fragment>
                      )}

                      {/* PROPOSAL SENT STATE BUTTONS */}
                      {isCompany && row.status === dealStatuses.PROPOSAL_SENT && (
                        <Fragment>
                          {row.currentProposal.sender === auth.uid && (
                            <Grid item>
                              <Typography
                                variant="body1"
                                className={classes.text}
                              >
                                Proposal Sent
                              </Typography>
                            </Grid>
                          )}
                          {row.currentProposal.sender !== auth.uid && (
                            <Grid item>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.acceptButton}
                                onClick={() => handleViewProposalClick(row)}
                              >
                                View Proposal
                              </Button>
                            </Grid>
                          )}
                          <Grid item>
                            <Button
                              color="secondary"
                              className={classes.unmatchButton}
                              variant="outlined"
                              onClick={() => this.openUnmatchDialog(row)}
                            >
                              Unmatch
                            </Button>
                          </Grid>
                        </Fragment>
                      )}
                      {!isCompany && row.status === dealStatuses.PROPOSAL_SENT && (
                        <Fragment>
                          {row.currentProposal.sender === auth.uid && (
                            <Grid item>
                              <Typography
                                variant="body1"
                                className={classes.text}
                              >
                                Proposal Sent
                              </Typography>
                            </Grid>
                          )}
                          {row.currentProposal.sender !== auth.uid && (
                            <Grid item>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.acceptButton}
                                onClick={() => handleViewProposalClick(row)}
                              >
                                View Proposal
                              </Button>
                            </Grid>
                          )}
                          <Grid item>
                            <Button
                              color="secondary"
                              className={classes.unmatchButton}
                              variant="outlined"
                              onClick={() => this.openUnmatchDialog(row)}
                            >
                              Unmatch
                            </Button>
                          </Grid>
                        </Fragment>
                      )}

                      {/* REVISION REQUESTED STATE */}
                      {isCompany &&
                        row.status === dealStatuses.REVISION_REQUESTED && (
                          <Fragment>
                            <Grid item>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.acceptButton}
                                onClick={() => handleProposeDealClick(row)}
                              >
                                Revise Deal
                              </Button>
                            </Grid>
                            <Grid item>
                              <Button
                                color="secondary"
                                className={classes.unmatchButton}
                                variant="outlined"
                                onClick={() => this.openUnmatchDialog(row)}
                              >
                                Unmatch
                              </Button>
                            </Grid>
                          </Fragment>
                        )}
                      {!isCompany &&
                        row.status === dealStatuses.REVISION_REQUESTED && (
                          <Fragment>
                            <Grid item>
                              <Typography
                                variant="body1"
                                className={classes.text}
                              >
                                waiting for revision
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Button
                                color="secondary"
                                className={classes.unmatchButton}
                                variant="outlined"
                                onClick={() => this.openUnmatchDialog(row)}
                              >
                                Unmatch
                              </Button>
                            </Grid>
                          </Fragment>
                        )}

                      {/* DEAL ACCEPTED BUTTONS */}
                      {isCompany && row.status === dealStatuses.DEAL_ACCEPTED && (
                        <Fragment>
                          <Grid item>
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.acceptButton}
                              onClick={() => handleEscrowFundsClick(row)}
                            >
                              Escrow Funds
                            </Button>
                          </Grid>
                        </Fragment>
                      )}
                      {!isCompany && row.status === dealStatuses.DEAL_ACCEPTED && (
                        <Fragment>
                          <Grid item>
                            <Typography
                              variant="body1"
                              className={classes.text}
                            >
                              waiting for funds in escrow
                            </Typography>
                          </Grid>
                        </Fragment>
                      )}
                      {/* DEAL ACTIVE BUTTONS */}
                      {isCompany && row.status === dealStatuses.ACTIVE && (
                        <Grid item>
                          <Typography variant="body1" className={classes.text}>
                            waiting for content
                          </Typography>
                        </Grid>
                      )}
                      {!isCompany && row.status === dealStatuses.ACTIVE && (
                        <React.Fragment>
                          <Grid item>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handleSubmitContentClick(row)}
                              className={classes.acceptButton}
                            >
                              Submit Content
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handleOpenCompleteModal(row)}
                              className={classes.acceptButton}
                            >
                              Complete Deal
                            </Button>
                          </Grid>
                        </React.Fragment>
                      )}
                      {/* CONTENT IN REVIEW BUTTONS */}
                      {isCompany &&
                        row.status === dealStatuses.CONTENT_COMPLETE && (
                          <Grid item>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handleReviewContentClick(row)}
                              className={classes.acceptButton}
                            >
                              Review Content
                            </Button>
                          </Grid>
                        )}
                      {!isCompany &&
                        row.status === dealStatuses.CONTENT_COMPLETE && (
                          <Grid item>
                            <Typography variant="body1">
                              content in review
                            </Typography>
                          </Grid>
                        )}

                      {/* CONTENT IN DISPUTE BUTTONS */}
                      {row.status === dealStatuses.DISPUTE_OPENED && (
                        <Grid item>
                          <Typography variant="body1">
                            content in dispute - you will be hearing from
                            HypePilot shortly
                          </Typography>
                        </Grid>
                      )}

                      {/* DEAL COMPLETE BUTTONS AND ARCHIVED DEAL BUTTONS */}
                      {row.status === dealStatuses.COMPLETE &&
                        ((row.user.isCompany && !row.influencerArchived) ||
                          (!row.user.isCompany && !row.companyArchived)) && (
                          <Fragment>
                            <Grid item>
                              <Typography
                                variant="body1"
                                className={classes.text}
                              >
                                Deal Complete
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                  this.archiveDealClick(row, row.user, true)
                                }
                                className={classes.acceptButton}
                              >
                                Archive Deal
                              </Button>
                            </Grid>
                          </Fragment>
                        )}
                      {(row.user.isCompany && row.influencerArchived) ||
                        (!row.user.isCompany && row.companyArchived && (
                          <Fragment>
                            <Grid item>
                              <Typography
                                variant="body1"
                                className={classes.text}
                              >
                                Deal Complete
                              </Typography>
                            </Grid>
                          </Fragment>
                        ))}
                    </Grid>
                  </Grid>
                </div>
                {(row.status === dealStatuses.DEAL_ACCEPTED ||
                  row.status === dealStatuses.ACTIVE ||
                  row.status === dealStatuses.CONTENT_COMPLETE ||
                  row.status === dealStatuses.DISPUTE_OPENED ||
                  row.status === dealStatuses.COMPLETE ||
                  row.status === dealStatuses.CONTENT_COMPLETE) && (
                  <div
                    className={classes.viewDealButton}
                    onClick={() => handleViewDealClick(row)}
                  >
                    <NavigateNextIcon className={classes.viewDealIcon} />
                  </div>
                )}
              </Paper>
            ))}
          {!tableRows.length && rowsLoaded && campaignsLoaded && !hasCampaign && (
            <Paper className={classes.noCurrentDeals}>
              <Grid container direction="row" justify="center">
                <Grid
                  container
                  alignItems="center"
                  sm={12}
                  justify="center"
                  className={classes.noDealsContainer}
                >
                  <Typography
                    variant="h6"
                    align="center"
                    justify="center"
                    className={classes.noCampText}
                  >
                    No deals yet -{' '}
                    <LinkText
                      className={classes.createCampLink}
                      onClick={() => this.navigateToCreateCampaign()}
                    >
                      Create a Campaign{' '}
                    </LinkText>
                    to start closing deals
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          )}
          {!tableRows.length &&
            rowsLoaded &&
            campaignsLoaded &&
            hasCampaign &&
            isCompany && (
              <Paper className={classes.noCurrentDeals}>
                <Grid container direction="row" justify="center">
                  <Grid
                    container
                    alignItems="center"
                    sm={12}
                    justify="center"
                    className={classes.noDealsContainer}
                  >
                    <Typography
                      variant="h6"
                      align="center"
                      justify="center"
                      className={classes.noCampText}
                    >
                      No deals yet -{' '}
                      <LinkText
                        className={classes.createCampLink}
                        onClick={() => this.navigateToDiscoverInfluencers()}
                      >
                        Invite Influencers{' '}
                      </LinkText>
                      to your campaign or check your
                      <LinkText
                        className={classes.createCampLink}
                        onClick={() => this.navigateToMatchFeed()}
                      >
                        {' '}
                        Match Feed{' '}
                      </LinkText>
                      to start closing deals
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            )}
          {!tableRows.length &&
            rowsLoaded &&
            campaignsLoaded &&
            hasCampaign &&
            !isCompany && (
              <Paper className={classes.noCurrentDeals}>
                <Grid container direction="row" justify="center">
                  <Grid
                    container
                    alignItems="center"
                    sm={12}
                    justify="center"
                    className={classes.noDealsContainer}
                  >
                    <Typography
                      variant="h6"
                      align="center"
                      justify="center"
                      className={classes.noCampText}
                    >
                      No deals yet -{' '}
                      <LinkText
                        className={classes.createCampLink}
                        onClick={() => this.navigateToDiscoverCampaigns()}
                      >
                        Apply to Campaigns{' '}
                      </LinkText>
                      or check your
                      <LinkText
                        className={classes.createCampLink}
                        onClick={() => this.navigateToMatchFeed()}
                      >
                        {' '}
                        Match Feed{' '}
                      </LinkText>
                      to start closing deals
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            )}
        </main>
        <Dialog
          id="payment-info-dialog"
          open={this.state.showRatingsDialog}
          onClose={this.props.handleCloseRatingDialog}
          disableAutoFocus={true}
          onBackdropClick={this.handleCloseRatingDialog.bind(this)}
          PaperProps={{
            style: {
              minHeight: '150px',
              minWidth: '250px',
              maxWigth: '350px',
              padding: '20px'
            }
          }}
        >
          <div className={classes.ratingContainer}>
            <Typography variant="h6" className={classes.ratingText}>
              Rate deal with{' '}
              {this.state.dealToRate.user
                ? this.state.dealToRate.user.displayName
                : ''}
            </Typography>
            <StarRatings
              starRatedColor="yellow"
              changeRating={this.changeRating.bind(this)}
              numberOfStars={5}
              name="rating"
              starDimension="20px"
              starSpacing="5px"
              starHoverColor="yellow"
            />
            <LinkText
              variant="body1"
              className={classes.archiveLink}
              onClick={() =>
                this.archiveDealClick(
                  this.state.dealToRate,
                  this.state.dealToRate.user,
                  false
                )
              }
            >
              archive without rating
            </LinkText>
          </div>
        </Dialog>
        <HpDialog
          infoText={
            'You will not be able to rematch with this user for this campaign. Are you sure you want to unmatch?'
          }
          isOpen={this.state.showUnmatchDialog}
          cancelText={'cancel'}
          confirmText={'unmatch'}
          onClose={this.closeUnmatchDialog}
          onConfirm={this.confirmUmatch}
        />
      </React.Fragment>
    );
  }
}

DealTable.propTypes = {
  tableRows: PropTypes.array,
  rowsLoaded: PropTypes.bool,
  viewSelectChangeHandler: PropTypes.func,
  tableView: PropTypes.string,
  handleProposeDealClick: PropTypes.func,
  handleViewProposalClick: PropTypes.func,
  handleBackClick: PropTypes.func,
  isCompany: PropTypes.bool
};

export default enhance(DealTable);



// WEBPACK FOOTER //
// ./src/components/deals/DealTable.js